import React, { useContext } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { AuthContext } from '../../../../helpers/AuthContext';
import InstanceLeftSidebar from '../../InstanceLeftSidebar';
import PageHeaderWithBreadcrumbs from '../../../../components/PageHeaderWithBreadcrumbs';
import MaterialsManagement from './MaterialsManagement';
import ChargeStrategies from './ChargeStrategies';

const EliteProductionChargeStrategies = () => {
  const { authState } = useContext(AuthContext);

  return (
    <div className="instance-dashboard">
      <InstanceLeftSidebar />
      <div className="rightSide">
        <div className="options-container fade-in-effect-usability">
          <div className="options-inner-container">
            <PageHeaderWithBreadcrumbs
              title="Charge Strategies"
              breadcrumb="Charge Strategies"
              includeButton={false}
            />
            <ChargeStrategies/>
          </div>
        </div>
      </div>
    </div>
  );
};


export default EliteProductionChargeStrategies;
